// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import StripeConfig from '../components/paymentProviderConfigs/StripeConfig';
import {actions as LogisticsAction} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    error: state.paymentMethodConfig.error,
    isSaving: state.paymentMethodConfig.isSaving,
    paymentMethod: state.paymentMethodConfig.paymentMethod,
    currency: state.currency.currency,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...LogisticsAction,
      },
      dispatch
    )
)(StripeConfig);
